module.exports = __webpack_public_path__ + "img/logo.96923d3a.png";